module.exports = __webpack_public_path__ + "img/fuxiaolei.61be3d7c.jpg";